import axios from "axios";

export const getLockStatus = async (productId) => {
  const { data } = await axios.get('/rapi/chemicals/' + productId + '/lock')
  return data
}

export const setLocked = async (productId, lockedValue) => {
  // TODO: Implementera notifikation vid upplåsning
  try {
    await axios.put('/rapi/chemicals/' + productId + '/setLocked', { isLocked: lockedValue });
  } catch (error) {
    if (!axios.isCancel(error)) {
      // TODO: Implementera felhantering
      return
    }
    throw error;
  }
}
